import React from 'react';
import { TotalCardContentStyle, Content } from './style';

export default function TotalCardContent() {
  return (
    <TotalCardContentStyle>
      <h4>999 | 9999 | 9999-9</h4>
      <Content>
        <p>Saldo inicial</p>
        <p>0,00</p>
      </Content>
      <Content>
        <p>Crédito(s)</p>
        <p>0,00</p>
      </Content>
      <Content>
        <p>Saldo Final</p>
        <p>0,00</p>
      </Content>
    </TotalCardContentStyle>
  );
}
